module.exports = __webpack_public_path__ + "84076c29b2f1bf3dfa7f52d509c0a9d9.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_2_0.eot
// module id = 208
// module chunks = 0